const numberAndLetter = value => {
  if (!value) {
    return value
  }

  return value.replace(/[^0-9a-zA-Z]+/g, '')
}

export default numberAndLetter



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/numberAndLetter.js